import { CommonModule, PercentPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';

import { CurrencyPipe } from '../../currency/currency.pipe';
import { DatePipe } from '../../date/date.pipe';
import { DashboardChartYAxisPipe } from './dashboard-chart-yaxis.pipe';
import { DashboardChartComponent } from './dashboard-chart.component';
import { DashboardChartSeriesPipe } from './dashboard-chart-series.pipe';

@NgModule({
  imports: [
    NgApexchartsModule,
    CommonModule,
    TranslateModule.forChild(),
  ],
  exports: [
    DashboardChartComponent
  ],
  declarations: [
    DashboardChartComponent,
    DashboardChartYAxisPipe,
    DashboardChartSeriesPipe,
  ],
  providers: [
    DatePipe,
    PercentPipe,
    CurrencyPipe,
  ],
})
export class DashboardChartModule { }
